import { useMemo } from 'react';
import { useUser } from '@/hooks';
import { mapUserLevelToRole } from '@/utils/roleMapper';
import { Role } from '@/config/planCaps';

/**
 * 현재 사용자의 역할을 반환하는 훅
 *
 * @example
 * const { role, isOwner, isEditor, isTester, isValidating } = useUserRole();
 *
 * if (isEditor) {
 *   // 편집자 전용 로직
 * }
 */
export default function useUserRole() {
  const { data: user, isValidating } = useUser();

  const role = useMemo<Role | undefined>(() => {
    if (!user?.level) {
      return undefined;
    }

    return mapUserLevelToRole(user.level);
  }, [user?.level]);

  const isOwner = role === 'owner';
  const isEditor = role === 'editor';
  const isTester = role === 'tester';

  return {
    role,
    isOwner,
    isEditor,
    isTester,
    isValidating
  };
}
